import { CopilotEngagementCategories, ScanningScheduleScoreThresholds } from 'consts/copilotControlConsts'

export const getScanningScheduleEngagementScore = scanningScheduleScore => {
  const numericScore = Number(scanningScheduleScore)

  if (scanningScheduleScore === null || scanningScheduleScore === undefined || isNaN(numericScore)) {
    return null
  }

  const entries = Object.entries(ScanningScheduleScoreThresholds)

  for (let i = 0; i < entries.length; i++) {
    const [key, threshold] = entries[i]
    if (numericScore <= threshold) {
      return key
    }
  }

  return CopilotEngagementCategories.Negative
}

export const getSentimentEngagementScore = sentimentScore => {
  const numericScore = Number(sentimentScore)

  if (sentimentScore === null || sentimentScore === undefined || isNaN(numericScore)) {
    return null
  }

  if (numericScore >= 4) {
    return CopilotEngagementCategories.Positive
  } else if (numericScore === 3) {
    return CopilotEngagementCategories.Neutral
  } else {
    return CopilotEngagementCategories.Negative
  }
}
